<template>
  <div>
    <b-row>
      <FileField
        v-model="file"
        class="col-12"
        :label="__('common.file')"
        name="file"
        required
      />
    </b-row>

    <div class="text-right">
      <b-button variant="primary" size="sm" @click="upload">
        <Icon class="mr-2" icon="upload" size="14" />
        {{ __('buttons.upload') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import ModalMixin from '@/General/Modal/ModalMixin.js'

export default {
  name: 'UploadModal',

  mixins: [ModalMixin],

  props: {
    meta: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },

  data() {
    return {
      file: null,
    }
  },

  methods: {
    upload() {
      let formData = new FormData()

      formData.append('file', this.file)

      if (this.meta.documentFolderId) {
        formData.append('document_folder_id', this.meta.documentFolderId)
      }

      if (this.$route.query.path) {
        formData.append('path', this.$route.query.path)
      }

      this.meta.uploadCallback &&
        this.meta
          .uploadCallback(formData)
          .then(() => {
            this.closeModal(this.__(`documents.file-upload-success`))
            this.onSuccess && this.onSuccess()
          })
          .catch((error) => this.setErrorsFromResponse(error))
    },
  },
}
</script>
